import { render } from "./ProblemPage.vue?vue&type=template&id=71c1bb03&scoped=true"
import script from "./ProblemPage.vue?vue&type=script&lang=js"
export * from "./ProblemPage.vue?vue&type=script&lang=js"

import "./ProblemPage.vue?vue&type=style&index=0&id=71c1bb03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c1bb03"]])

export default __exports__